export const SET_REPORT_DATE_FILTER = 'reportFilters/SET_REPORT_DATE_FILTER';
